// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file evalreview/v1/evalreview.proto (package evalreview.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file evalreview/v1/evalreview.proto.
 */
export const file_evalreview_v1_evalreview: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * Batch is a group of cases for review.
 *
 * @generated from message evalreview.v1.Batch
 */
export type Batch = Message<"evalreview.v1.Batch"> & {
  /**
   * FA's BATCH_ID when the cases carry one, else an ingest-day bucket
   * ("intake-2026-07-27") for cases that arrived before the FA leg.
   *
   * This is also the ACCESS SCOPE KEY — a reviewer sees a batch because their
   * queue names this id. Listing and scoping must use the same value or a case
   * appears in a queue that cannot open it.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * "ACME · B-118", or "PDF intake - Jul 27"
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 3;
   */
  receivedAt?: Timestamp | undefined;

  /**
   * Counts over the cases THIS CALLER can see — not FA's BATCH_COUNT and not
   * the observed ACTIVE_EPISODES. Those two disagree on roughly a third of
   * batches, and either would state a total the reviewer's own list cannot
   * account for, reading as an incomplete batch rather than a scoped one.
   *
   * @generated from field: int32 case_count = 4;
   */
  caseCount: number;

  /**
   * @generated from field: int32 reviewed_count = 5;
   */
  reviewedCount: number;

  /**
   * open | in_progress | complete
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * The client. In FA the JOB is the client account — there is no separate
   * client entity — so these come from BATCH.JOB_ID. Empty for ingest-day
   * buckets, which belong to no client by construction.
   *
   * Not PHI: a client name is a business relationship, not a patient.
   *
   * JOB_NAME, e.g. "Acme Health"
   *
   * @generated from field: string client = 7;
   */
  client: string;

  /**
   * JOB_CODE, e.g. "ACME"
   *
   * @generated from field: string job_code = 8;
   */
  jobCode: string;

  /**
   * The distinct human coders whose work this batch contains, as FA's raw
   * numeric CHANGEDBY_ID. The batch list showed an empty coder column because
   * this did not exist and the client hardcoded [].
   *
   * Raw ids, not names: resolving them needs ABC_OTO_P1.USER_TABLE, which
   * DATA_EXT cannot read. Shipping the id is what lets the column mean
   * something before that grant lands, and the join is then a display change.
   *
   * Not PHI — a coder is staff, not a patient. Note it is nonetheless
   * unblinding-adjacent: CoderCtx is deliberately kept off CodedResult so a
   * slot never identifies which side is human. At BATCH level that distinction
   * does not exist (the batch has no A/B slots), so this is safe here and
   * would not be on a case's coded result.
   *
   * @generated from field: repeated string coder_ids = 9;
   */
  coderIds: string[];

  /**
   * The same coders, resolved to names through FA's user view, positionally
   * aligned with coder_ids.
   *
   * Parallel arrays rather than a message, because coder_ids is already load
   * bearing on the wire and renaming it would break every client at once. A
   * name may be absent where an id did not resolve, so a client must fall back
   * to the id by INDEX and never assume equal length.
   *
   * @generated from field: repeated string coder_names = 22;
   */
  coderNames: string[];

  /**
   * How many of this batch's cases each coder in coder_ids worked, positionally
   * aligned with it.
   *
   * Exists so a client can group batches by coder WITHOUT double-counting. A
   * batch is not one person's work — the ones carrying the volume are worked by
   * three to five coders — so a client grouping on coder_ids alone lists one
   * batch under each of them and every case total it prints is the batch's,
   * counted once per coder. Sending the split lets the client attribute a batch
   * to the coder who did most of it and keep its totals true.
   *
   * Same parallel-array discipline as coder_names, and the same warning: a
   * client must index, never assume equal length.
   *
   * @generated from field: repeated int32 coder_case_counts = 23;
   */
  coderCaseCounts: number[];

  /**
   * FA's own batch status, as opposed to `status` above, which is derived from
   * OUR review progress and therefore reads "open" on every batch until a
   * reviewer starts — a column identical on all 1,381 rows.
   *
   * The RAW code, deliberately unmapped. Measured over 277 sampled batches on
   * 2026-08-08 it is the only FA batch column that varies: 'C' 87.7%, 'P'
   * 12.3%. What those letters MEAN is not established, so this carries the
   * code rather than a guessed label — "Closed"/"Pending" is the obvious
   * reading and obvious readings of FA status columns have been wrong before
   * (BATCH_CD_STATUS_CODE is 'N' on batches demonstrably coded in the window).
   *
   * Deliberately NOT carried, all measured constant over the same sample and
   * therefore dead on screen: PRIORITY ('1', 100%), HOLD_CODE (null, 100%),
   * BATCH_TYPE ('C', 100%), CODING_STATUS ('N', 99.6%). Do not re-add one
   * without re-measuring — an always-identical column is the fault this field
   * exists to correct, not a feature.
   *
   * BATCH.BATCH_STATUS, raw
   *
   * @generated from field: string fa_status = 10;
   */
  faStatus: string;

  /**
   * FA's own batch code (BATCH.BATCH_CODE) — the identifier a reviewer
   * recognises and the one FA's own coding batch list leads with.
   *
   * Separate from `label`, which pre-concatenates client and code ("ACME ·
   * B-118"). The card rendered `label`, then the client again, then the job
   * code as a chip: the same client on one row three times. Sending the parts
   * lets the view show each once.
   *
   * @generated from field: string batch_code = 11;
   */
  batchCode: string;

  /**
   * How the batch stands with FA's own coders.
   *
   * The reviewer's queue defaults to batches that are worth reviewing — coding
   * complete, or the batch closed — and a closed batch that is NOT fully coded
   * shows the split rather than hiding it. Uncoded is derived (active minus
   * coded) and clamped, so it is not carried.
   *
   * Batch-level from FA, never aggregated from this batch's cases: a batch
   * whose cases we have not ingested would report zero coded, which reads as
   * "nothing done" rather than "not looked at yet".
   *
   * @generated from field: int32 active_episodes = 12;
   */
  activeEpisodes: number;

  /**
   * @generated from field: int32 coded_episodes = 13;
   */
  codedEpisodes: number;

  /**
   * @generated from field: int32 inactive_episodes = 14;
   */
  inactiveEpisodes: number;

  /**
   * @generated from field: bool coding_complete = 15;
   */
  codingComplete: boolean;

  /**
   * FA's DECLARED document count (BATCH.BATCH_COUNT), which disagrees with the
   * observed active count on roughly a third of batches. Carried BESIDE the
   * observed figure rather than instead of it: a mismatch means episodes are
   * missing or filtered, and a reviewer shown only one number reads a short
   * batch as small rather than as incomplete.
   *
   * @generated from field: int32 declared_count = 16;
   */
  declaredCount: number;

  /**
   * BATCH_CD_STATUS_CODE — the CODING stage specifically, as opposed to
   * fa_status, which is the batch overall and stays open while payment posting
   * is outstanding, long after coding finished.
   *
   * @generated from field: string coding_status = 17;
   */
  codingStatus: string;

  /**
   * Dates FA's own batch list shows and a reviewer sorts by. Timestamps, not
   * formatted strings: the batch list sorted lexically on a locale-formatted
   * date and put 8/7 after 8/18.
   *
   * @generated from field: google.protobuf.Timestamp close_date = 18;
   */
  closeDate?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp qc_due_date = 19;
   */
  qcDueDate?: Timestamp | undefined;

  /**
   * How many of this batch's cases the two sides disagree on, and how many
   * could be compared at all.
   *
   * COMPARABLE IS THE ONE THAT MATTERS. Only a case with both sides has an
   * agreement to measure, and today most have one — FA populates CODER_ID on
   * roughly a tenth of episodes at ingest. A card showing "0 with
   * discrepancies" over a batch where nothing was comparable states agreement
   * that was never established, which is what it did on every batch.
   *
   * @generated from field: int32 discrepancy_case_count = 20;
   */
  discrepancyCaseCount: number;

  /**
   * @generated from field: int32 comparable_case_count = 21;
   */
  comparableCaseCount: number;
};

/**
 * Describes the message evalreview.v1.Batch.
 * Use `create(BatchSchema)` to create a new message.
 */
export const BatchSchema: GenMessage<Batch> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 0);

/**
 * @generated from message evalreview.v1.ListBatchesRequest
 */
export type ListBatchesRequest = Message<"evalreview.v1.ListBatchesRequest"> & {
};

/**
 * Describes the message evalreview.v1.ListBatchesRequest.
 * Use `create(ListBatchesRequestSchema)` to create a new message.
 */
export const ListBatchesRequestSchema: GenMessage<ListBatchesRequest> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 1);

/**
 * @generated from message evalreview.v1.ListBatchesResponse
 */
export type ListBatchesResponse = Message<"evalreview.v1.ListBatchesResponse"> & {
  /**
   * @generated from field: repeated evalreview.v1.Batch batches = 1;
   */
  batches: Batch[];
};

/**
 * Describes the message evalreview.v1.ListBatchesResponse.
 * Use `create(ListBatchesResponseSchema)` to create a new message.
 */
export const ListBatchesResponseSchema: GenMessage<ListBatchesResponse> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 2);

/**
 * CodedResult mirrors the web CodedFields shape. It carries NO provenance
 * (source/model/confidence) — that is withheld server-side.
 *
 * EVERY FIELD HERE MUST BE PRODUCIBLE BY BOTH SIDES, OR BY NEITHER. A field
 * only one leg can fill is a per-case unblinding oracle: the slot holding a
 * value IS that leg, and because the A/B arrangement is stable per case, one
 * such case teaches the reviewer the arrangement for every later case they see.
 * Symmetric absence is safe (emergency / unusual_position are empty on both
 * sides today); asymmetric presence is not. Adding a field is therefore a
 * PAIRED change with both folds — see parseAgentResult / parseCoderResult in
 * platform/internal/evalmaterializer/apply.go, whose symmetry is pinned by
 * TestComparedResultFieldsAreSymmetric.
 *
 * @generated from message evalreview.v1.CodedResult
 */
export type CodedResult = Message<"evalreview.v1.CodedResult"> & {
  /**
   * @generated from field: string surgical_cpt = 1;
   */
  surgicalCpt: string;

  /**
   * @generated from field: string anesthesia_cpt = 2;
   */
  anesthesiaCpt: string;

  /**
   * @generated from field: string primary_icd = 3;
   */
  primaryIcd: string;

  /**
   * @generated from field: repeated string additional_icd = 4;
   */
  additionalIcd: string[];

  /**
   * @generated from field: repeated string modifiers = 6;
   */
  modifiers: string[];

  /**
   * @generated from field: string phys_status = 7;
   */
  physStatus: string;

  /**
   * @generated from field: bool emergency = 8;
   */
  emergency: boolean;

  /**
   * @generated from field: bool unusual_position = 9;
   */
  unusualPosition: boolean;
};

/**
 * Describes the message evalreview.v1.CodedResult.
 * Use `create(CodedResultSchema)` to create a new message.
 */
export const CodedResultSchema: GenMessage<CodedResult> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 3);

/**
 * BlindCase is a case with an opaque A/B result pair. It deliberately has no
 * agent/coder/flip field. In M1 only one side (the agent) is present, so
 * has_b is false until the FA coder leg (M2) lands.
 *
 * @generated from message evalreview.v1.BlindCase
 */
export type BlindCase = Message<"evalreview.v1.BlindCase"> & {
  /**
   * = DCN
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string batch_id = 2;
   */
  batchId: string;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 3;
   */
  receivedAt?: Timestamp | undefined;

  /**
   * received | submitted | coded | failed
   *
   * @generated from field: string coding_status = 4;
   */
  codingStatus: string;

  /**
   * unreviewed | submitted
   *
   * @generated from field: string review_status = 5;
   */
  reviewStatus: string;

  /**
   * set when coding_status == failed
   *
   * @generated from field: string coding_error = 6;
   */
  codingError: string;

  /**
   * @generated from field: evalreview.v1.CodedResult a = 7;
   */
  a?: CodedResult | undefined;

  /**
   * @generated from field: evalreview.v1.CodedResult b = 8;
   */
  b?: CodedResult | undefined;

  /**
   * @generated from field: bool has_a = 9;
   */
  hasA: boolean;

  /**
   * @generated from field: bool has_b = 10;
   */
  hasB: boolean;

  /**
   * Blob id of the source anesthesia-record PDF — the document the reviewer
   * checks the codes against.
   *
   * Carries no provenance and is safe alongside the blind: it is the SHARED
   * input both sides coded from, not either side's output.
   *
   * Empty when the case has no stored document (the no-blobstore dev fallback,
   * or a coder-only case that arrived from FA without a PDF). The UI must treat
   * empty as "no document" and show that plainly — before this field existed it
   * rendered a bundled SAMPLE pdf, which looked like the case's own record.
   *
   * @generated from field: string document_blob_id = 11;
   */
  documentBlobId: string;

  /**
   * The same context the queue row carries, so the review screen can show who
   * and where without a second round trip.
   *
   * @generated from field: evalreview.v1.EpisodeContext episode = 12;
   */
  episode?: EpisodeContext | undefined;

  /**
   * @generated from field: evalreview.v1.PatientContext patient = 13;
   */
  patient?: PatientContext | undefined;

  /**
   * FA's EPISODE_ID. Same field, same reason and same fallback as
   * CaseSummary.episode_id — see it.
   *
   * @generated from field: string episode_id = 14;
   */
  episodeId: string;
};

/**
 * Describes the message evalreview.v1.BlindCase.
 * Use `create(BlindCaseSchema)` to create a new message.
 */
export const BlindCaseSchema: GenMessage<BlindCase> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 4);

/**
 * EpisodeContext is FA's NON-PHI context for one episode: where and when it
 * happened, who the providers of record were, and where FA's own pipeline has
 * got to with it.
 *
 * Not PHI: none of it identifies a patient. Facility, room, service date and
 * staff ids describe the encounter, not the person. It is served to anyone who
 * can open the case, which is the same population that already sees the coded
 * results.
 *
 * Deliberately NO procedure description. FA's flattened episode query carries
 * ids and codes, not narrative — EPISODE_PROCEDURE_ID is a key, not a name — so
 * there is nothing here to fill a "procedure" column with. The surgical CPT the
 * two sides assigned is the closest thing, and it lives in the A/B slots where
 * it belongs. Inventing a procedure string from one slot would name that slot.
 *
 * @generated from message evalreview.v1.EpisodeContext
 */
export type EpisodeContext = Message<"evalreview.v1.EpisodeContext"> & {
  /**
   * @generated from field: string facility_id = 1;
   */
  facilityId: string;

  /**
   * FA's name for facility_id, so a reviewer sees "Houston Methodist" rather
   * than "71796" — a number they can neither act on nor look up.
   *
   * Both are carried, and the id is NOT redundant: FACILITY.FACILITY_NAME is
   * nullable in FA (verified against PROD as DATA_EXT, 2026-08-27), so an
   * episode can hold a real facility id and no name. A client falls back to the
   * id and SAYS it is doing so, the same way an absent FA episode id falls back
   * to the DCN — two identifiers that look alike must never be swapped
   * silently.
   *
   * Not PHI: a facility is an organization, not a patient. It is nonetheless
   * flagged as a PHI/PII candidate by the schema profiler's name-based
   * heuristic (HUB-344), so it is worth FA SME confirmation rather than an
   * assumption.
   *
   * @generated from field: string facility_name = 18;
   */
  facilityName: string;

  /**
   * @generated from field: string service_start_date = 2;
   */
  serviceStartDate: string;

  /**
   * @generated from field: string service_end_date = 3;
   */
  serviceEndDate: string;

  /**
   * @generated from field: string place_of_service = 4;
   */
  placeOfService: string;

  /**
   * @generated from field: string operating_room = 5;
   */
  operatingRoom: string;

  /**
   * @generated from field: string anesthesia_type = 6;
   */
  anesthesiaType: string;

  /**
   * @generated from field: string provider_id_of_record = 7;
   */
  providerIdOfRecord: string;

  /**
   * @generated from field: string crna_id_of_record = 8;
   */
  crnaIdOfRecord: string;

  /**
   * @generated from field: string day_units = 9;
   */
  dayUnits: string;

  /**
   * @generated from field: string concurrency_id = 10;
   */
  concurrencyId: string;

  /**
   * Who coded it in FA, and when.
   *
   * coder_id is EPISODE_PROCEDURE.CREATE_USER_ID — what FirstClaim's own DAO
   * writes when a coder saves. It was CHANGEDBY_ID filtered to a COLUMN_NAME
   * list, which attributed 10.7% of coded episodes and left batches of coded
   * work reporting no coder at all.
   *
   * On the CASE, never on a CodedResult. Only one side of the comparison has a
   * human coder, so a slot carrying this would name that slot — the blind's
   * sharpest edge. At case level it is display identity, exactly as the batch's
   * coder_ids already are.
   *
   * @generated from field: string coder_id = 11;
   */
  coderId: string;

  /**
   * @generated from field: string coded_when = 12;
   */
  codedWhen: string;

  /**
   * coder_name resolves coder_id through FA's user view, so a reviewer sees a
   * person rather than "3016635".
   *
   * It is no more revealing than the id for BLINDING purposes: the A/B
   * arrangement is HMAC(study_key, dcn) and takes no coder input, so neither
   * form indicates which slot is which. It is, however, staff PII where the id
   * is pseudonymous. Optional — an id that does not resolve yields the id
   * alone, so absence means "no name on file", never "no coder".
   *
   * @generated from field: string coder_name = 17;
   */
  coderName: string;

  /**
   * FA's own per-stage pipeline status (PR / CD / PE) and QC outcome.
   *
   * @generated from field: string pr_status = 13;
   */
  prStatus: string;

  /**
   * @generated from field: string cd_status = 14;
   */
  cdStatus: string;

  /**
   * @generated from field: string pe_status = 15;
   */
  peStatus: string;

  /**
   * @generated from field: string qc_error_type = 16;
   */
  qcErrorType: string;
};

/**
 * Describes the message evalreview.v1.EpisodeContext.
 * Use `create(EpisodeContextSchema)` to create a new message.
 */
export const EpisodeContextSchema: GenMessage<EpisodeContext> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 5);

/**
 * PatientContext is the PHI half: who the case is about.
 *
 * ⚠ PHI. Served only to a caller whose grant confers it; see phiGrantOf. Never
 * logged, never in a query key, never in a URL.
 *
 * # What is deliberately ABSENT, and why it must stay absent
 *
 * FIRST NAME and DATE OF BIRTH are not here. Oracle Data Redaction is active
 * for the DATA_EXT account, so FA hands us "Bxxxx" for the first name and a
 * YEAR-SHIFTED birth date (a live row read 2096-10-18 for a real 2000-10-18).
 *
 * A year-shifted DOB is the dangerous one. This screen exists for a reviewer to
 * judge whether codes are right, and several anesthesia decisions turn on age —
 * physical status, age-based qualifying circumstances. An age computed from a
 * shifted year is a plausible number that is simply false, and a reviewer has
 * no way to see that from the screen. Withholding it costs a field; sending it
 * invites a confidently wrong verdict.
 *
 * The subscriber columns on a coverage are OUTSIDE the redaction policy and for
 * a self-subscriber describe the same person, so they hold the real first name
 * and DOB. They must never be used to fill these in: the subscriber is only the
 * patient when RLTN_CODE says so, and substituting one for the other is wrong
 * for every dependent case.
 *
 * @generated from message evalreview.v1.PatientContext
 */
export type PatientContext = Message<"evalreview.v1.PatientContext"> & {
  /**
   * @generated from field: string last_name = 1;
   */
  lastName: string;

  /**
   * @generated from field: string mrn = 2;
   */
  mrn: string;

  /**
   * @generated from field: string gender = 3;
   */
  gender: string;

  /**
   * @generated from field: string account_number = 4;
   */
  accountNumber: string;

  /**
   * Primary coverage, as FA orders it.
   *
   * @generated from field: string payer = 5;
   */
  payer: string;

  /**
   * @generated from field: string payer_plan = 6;
   */
  payerPlan: string;
};

/**
 * Describes the message evalreview.v1.PatientContext.
 * Use `create(PatientContextSchema)` to create a new message.
 */
export const PatientContextSchema: GenMessage<PatientContext> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 6);

/**
 * CaseSummary is the lightweight per-case row for the review queue (no coded
 * results — those come from GetCase when a case is opened).
 *
 * @generated from message evalreview.v1.CaseSummary
 */
export type CaseSummary = Message<"evalreview.v1.CaseSummary"> & {
  /**
   * = DCN
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * FA's EPISODE_ID — the identifier a reviewer recognises and the one they can
   * carry back into FA.
   *
   * The `id` above is the DCN, which is the correlation key across this vertical
   * and stays the key: it is what the case is stored and addressed by. But it is
   * NOT a good display identifier. A DCN is scoped per job, so the same number
   * belongs to different patients across clients (HUB-633), and a reviewer
   * reading one off the screen cannot look it up.
   *
   * Empty when no FA leg has landed for the case (a PDF-only, agent-only case).
   * A client must fall back to `id` rather than render a blank identity.
   *
   * @generated from field: string episode_id = 14;
   */
  episodeId: string;

  /**
   * @generated from field: string batch_id = 2;
   */
  batchId: string;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 3;
   */
  receivedAt?: Timestamp | undefined;

  /**
   * received | submitted | coded | failed
   *
   * @generated from field: string coding_status = 4;
   */
  codingStatus: string;

  /**
   * unreviewed | submitted
   *
   * @generated from field: string review_status = 5;
   */
  reviewStatus: string;

  /**
   * @generated from field: bool has_a = 6;
   */
  hasA: boolean;

  /**
   * @generated from field: bool has_b = 7;
   */
  hasB: boolean;

  /**
   * The case-list columns. Both were stored in the read model and served by
   * nothing, so every row rendered an em dash under "Patient" and blanks under
   * procedure, payer and facility — a queue that could not tell one case from
   * another except by its DCN.
   *
   * @generated from field: evalreview.v1.EpisodeContext episode = 8;
   */
  episode?: EpisodeContext | undefined;

  /**
   * Present only when the caller's grant confers PHI. Absent is not "no
   * patient" — the UI must say which it is, or a reviewer reads a permissions
   * outcome as missing data.
   *
   * @generated from field: evalreview.v1.PatientContext patient = 9;
   */
  patient?: PatientContext | undefined;

  /**
   * The surgical CPT each opaque slot assigned — the queue's one-field teaser.
   *
   * Blind-safe: two opaque slots, exactly as the pair already is on the case
   * detail. It is a teaser rather than the whole result because the queue is
   * for choosing what to open, not for judging.
   *
   * @generated from field: string surgical_a = 10;
   */
  surgicalA: string;

  /**
   * @generated from field: string surgical_b = 11;
   */
  surgicalB: string;

  /**
   * How many compared fields the two slots differ on, and the denominator.
   *
   * The denominator crosses the wire so the client stops counting its own copy
   * of the field list: a queue rendering "5 of 6" against a list the server has
   * since changed states a ratio neither side agreed to.
   *
   * BOTH ARE MEANINGLESS UNLESS has_a AND has_b. There is no separate
   * "compared" flag because those two already carry it, and a third field could
   * disagree with them. A client must not render discrepancy_count == 0 as
   * agreement without checking: zero-because-identical and
   * zero-because-nothing-was-compared are opposite facts, and the queue used to
   * render both as a green "Full match" — asserting the two sides agreed on
   * every case in the study, having compared none of them.
   *
   * @generated from field: int32 discrepancy_count = 12;
   */
  discrepancyCount: number;

  /**
   * @generated from field: int32 compared_field_count = 13;
   */
  comparedFieldCount: number;
};

/**
 * Describes the message evalreview.v1.CaseSummary.
 * Use `create(CaseSummarySchema)` to create a new message.
 */
export const CaseSummarySchema: GenMessage<CaseSummary> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 7);

/**
 * @generated from message evalreview.v1.ListCasesRequest
 */
export type ListCasesRequest = Message<"evalreview.v1.ListCasesRequest"> & {
  /**
   * @generated from field: string batch_id = 1;
   */
  batchId: string;
};

/**
 * Describes the message evalreview.v1.ListCasesRequest.
 * Use `create(ListCasesRequestSchema)` to create a new message.
 */
export const ListCasesRequestSchema: GenMessage<ListCasesRequest> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 8);

/**
 * @generated from message evalreview.v1.ListCasesResponse
 */
export type ListCasesResponse = Message<"evalreview.v1.ListCasesResponse"> & {
  /**
   * @generated from field: repeated evalreview.v1.CaseSummary cases = 1;
   */
  cases: CaseSummary[];
};

/**
 * Describes the message evalreview.v1.ListCasesResponse.
 * Use `create(ListCasesResponseSchema)` to create a new message.
 */
export const ListCasesResponseSchema: GenMessage<ListCasesResponse> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 9);

/**
 * @generated from message evalreview.v1.GetCaseRequest
 */
export type GetCaseRequest = Message<"evalreview.v1.GetCaseRequest"> & {
  /**
   * DCN
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message evalreview.v1.GetCaseRequest.
 * Use `create(GetCaseRequestSchema)` to create a new message.
 */
export const GetCaseRequestSchema: GenMessage<GetCaseRequest> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 10);

/**
 * @generated from message evalreview.v1.GetCaseResponse
 */
export type GetCaseResponse = Message<"evalreview.v1.GetCaseResponse"> & {
  /**
   * @generated from field: evalreview.v1.BlindCase case = 1;
   */
  case?: BlindCase | undefined;
};

/**
 * Describes the message evalreview.v1.GetCaseResponse.
 * Use `create(GetCaseResponseSchema)` to create a new message.
 */
export const GetCaseResponseSchema: GenMessage<GetCaseResponse> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 11);

/**
 * CodebookEntry is a code's human-readable title + description.
 *
 * @generated from message evalreview.v1.CodebookEntry
 */
export type CodebookEntry = Message<"evalreview.v1.CodebookEntry"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * cpt | asa | hcpcs | icd | mod | phys
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * ASA base units (kind == asa)
   *
   * @generated from field: double base = 5;
   */
  base: number;
};

/**
 * Describes the message evalreview.v1.CodebookEntry.
 * Use `create(CodebookEntrySchema)` to create a new message.
 */
export const CodebookEntrySchema: GenMessage<CodebookEntry> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 12);

/**
 * @generated from message evalreview.v1.SearchCodebookRequest
 */
export type SearchCodebookRequest = Message<"evalreview.v1.SearchCodebookRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * optional filter
   *
   * @generated from field: string kind = 2;
   */
  kind: string;
};

/**
 * Describes the message evalreview.v1.SearchCodebookRequest.
 * Use `create(SearchCodebookRequestSchema)` to create a new message.
 */
export const SearchCodebookRequestSchema: GenMessage<SearchCodebookRequest> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 13);

/**
 * @generated from message evalreview.v1.SearchCodebookResponse
 */
export type SearchCodebookResponse = Message<"evalreview.v1.SearchCodebookResponse"> & {
  /**
   * @generated from field: repeated evalreview.v1.CodebookEntry entries = 1;
   */
  entries: CodebookEntry[];
};

/**
 * Describes the message evalreview.v1.SearchCodebookResponse.
 * Use `create(SearchCodebookResponseSchema)` to create a new message.
 */
export const SearchCodebookResponseSchema: GenMessage<SearchCodebookResponse> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 14);

/**
 * CodeVerdict is one code's adjudication within a field.
 *
 * A multi-value field (additional_icd, modifiers) is reviewed code by code, so
 * the field-level verdict is a SUMMARY of these rows, not the reviewer's whole
 * judgement. Carrying the rows means the event keeps which code was rejected
 * and why — the actionable half — instead of only "the two lists disagreed".
 *
 * A single-value field carries rows too, but only on a "neither" verdict: the
 * code the reviewer picked as correct, as a row with added=true. That is the
 * one place the reviewer's replacement answer exists, and it is what lets a
 * rejection of both sides still resolve a selection — see selection_unresolved
 * on GetProgramMetricsResponse.
 *
 * @generated from message evalreview.v1.CodeVerdict
 */
export type CodeVerdict = Message<"evalreview.v1.CodeVerdict"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: bool correct = 2;
   */
  correct: boolean;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string note = 4;
   */
  note: string;

  /**
   * added marks a code the REVIEWER supplied because the record supports it and
   * neither result coded it. Distinct from correct=true on a row that came from
   * a slot: one endorses a side's code, the other says both sides missed it.
   *
   * @generated from field: bool added = 5;
   */
  added: boolean;
};

/**
 * Describes the message evalreview.v1.CodeVerdict.
 * Use `create(CodeVerdictSchema)` to create a new message.
 */
export const CodeVerdictSchema: GenMessage<CodeVerdict> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 15);

/**
 * FieldVerdict is the reviewer's judgement on one compared field.
 *
 * @generated from message evalreview.v1.FieldVerdict
 */
export type FieldVerdict = Message<"evalreview.v1.FieldVerdict"> & {
  /**
   * surgical_cpt | primary_icd | ...
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * both | a | b | neither
   *
   * @generated from field: string verdict = 2;
   */
  verdict: string;

  /**
   * @generated from field: repeated string reasons = 3;
   */
  reasons: string[];

  /**
   * @generated from field: string note = 4;
   */
  note: string;

  /**
   * codes is the per-code adjudication: every code in the A∪B union for a
   * multi-value field, and — on a "neither" verdict — the reviewer's chosen
   * correct code for a single-value one. See CodeVerdict.
   *
   * @generated from field: repeated evalreview.v1.CodeVerdict codes = 5;
   */
  codes: CodeVerdict[];
};

/**
 * Describes the message evalreview.v1.FieldVerdict.
 * Use `create(FieldVerdictSchema)` to create a new message.
 */
export const FieldVerdictSchema: GenMessage<FieldVerdict> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 16);

/**
 * @generated from message evalreview.v1.SubmitReviewRequest
 */
export type SubmitReviewRequest = Message<"evalreview.v1.SubmitReviewRequest"> & {
  /**
   * DCN
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * submitted | draft | missing_information | incomplete_documentation | needs_escalation
   *
   * @generated from field: string disposition = 2;
   */
  disposition: string;

  /**
   * @generated from field: repeated evalreview.v1.FieldVerdict field_verdicts = 3;
   */
  fieldVerdicts: FieldVerdict[];

  /**
   * @generated from field: string note = 4;
   */
  note: string;
};

/**
 * Describes the message evalreview.v1.SubmitReviewRequest.
 * Use `create(SubmitReviewRequestSchema)` to create a new message.
 */
export const SubmitReviewRequestSchema: GenMessage<SubmitReviewRequest> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 17);

/**
 * @generated from message evalreview.v1.SubmitReviewResponse
 */
export type SubmitReviewResponse = Message<"evalreview.v1.SubmitReviewResponse"> & {
  /**
   * accepted is true only when the review was appended to the event stream.
   * A client that ignores it cannot tell a recorded review from a lost one, so
   * the workbench treats anything other than true as a failed submit and keeps
   * the case open — see liveAuditSource.submitAudit.
   *
   * @generated from field: bool accepted = 1;
   */
  accepted: boolean;
};

/**
 * Describes the message evalreview.v1.SubmitReviewResponse.
 * Use `create(SubmitReviewResponseSchema)` to create a new message.
 */
export const SubmitReviewResponseSchema: GenMessage<SubmitReviewResponse> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 18);

/**
 * @generated from message evalreview.v1.GetProgramMetricsRequest
 */
export type GetProgramMetricsRequest = Message<"evalreview.v1.GetProgramMetricsRequest"> & {
  /**
   * IANA zone the trend buckets are cut in, e.g. "America/Chicago". Empty
   * means UTC. An unknown zone is InvalidArgument.
   *
   * @generated from field: string time_zone = 1;
   */
  timeZone: string;
};

/**
 * Describes the message evalreview.v1.GetProgramMetricsRequest.
 * Use `create(GetProgramMetricsRequestSchema)` to create a new message.
 */
export const GetProgramMetricsRequestSchema: GenMessage<GetProgramMetricsRequest> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 19);

/**
 * FieldMetrics is the per-field breakdown, where the actionable signal lives:
 * a uniform gap and a gap concentrated in one field are different problems.
 *
 * @generated from message evalreview.v1.FieldMetrics
 */
export type FieldMetrics = Message<"evalreview.v1.FieldMetrics"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: int32 agent_correct = 2;
   */
  agentCorrect: number;

  /**
   * @generated from field: int32 coder_correct = 3;
   */
  coderCorrect: number;

  /**
   * @generated from field: int32 both = 4;
   */
  both: number;

  /**
   * @generated from field: int32 neither = 5;
   */
  neither: number;

  /**
   * @generated from field: int32 judged = 6;
   */
  judged: number;

  /**
   * Deprecated in favour of top_reason_counts, which says by HOW MUCH a reason
   * leads. Kept on the wire rather than replaced: changing field 7's type is a
   * breaking change for any client already reading it.
   *
   * @generated from field: repeated string top_reasons = 7;
   */
  topReasons: string[];

  /**
   * Ranked, COUNTED reasons for THIS field — "why does this field go wrong, and
   * how often". The study-wide roll-up cannot answer it: a reason that dominates
   * one field is diluted there by every field that never cites it.
   *
   * @generated from field: repeated evalreview.v1.ReasonMetrics top_reason_counts = 8;
   */
  topReasonCounts: ReasonMetrics[];
};

/**
 * Describes the message evalreview.v1.FieldMetrics.
 * Use `create(FieldMetricsSchema)` to create a new message.
 */
export const FieldMetricsSchema: GenMessage<FieldMetrics> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 20);

/**
 * CodeMetrics is one specific code and how often the side that produced it was
 * judged wrong. Keyed by field AND code: the same code billed in two positions
 * is two different mistakes with two different fixes.
 *
 * @generated from message evalreview.v1.CodeMetrics
 */
export type CodeMetrics = Message<"evalreview.v1.CodeMetrics"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * surgical_cpt | primary_icd | ...
   *
   * @generated from field: string field = 2;
   */
  field: string;

  /**
   * agent_wrong and coder_wrong split the row by the side that produced the
   * code. AUDITOR-ONLY, both ZERO for everyone else — not absent, because a
   * scalar cannot be absent, so read them together with wrong: wrong > 0 with
   * both splits 0 means "not entitled", never "nobody was wrong".
   *
   * Withheld for the same reason as example_dcns. The floor is on the TOTAL,
   * so a one-sided row is publishable, and a reviewer who judged a case
   * carrying this code reads it as which slot of THEIR case was the agent —
   * the server never sends the case id, but the reviewer already has it.
   *
   * @generated from field: int32 agent_wrong = 3;
   */
  agentWrong: number;

  /**
   * @generated from field: int32 coder_wrong = 4;
   */
  coderWrong: number;

  /**
   * agent_wrong + coder_wrong, the rank key; sent to every caller
   *
   * @generated from field: int32 wrong = 5;
   */
  wrong: number;

  /**
   * reasons is why THIS code was judged wrong, ranked with counts. Not
   * floored: the row already cleared the floor and a reason names no side.
   *
   * @generated from field: repeated evalreview.v1.ReasonMetrics reasons = 6;
   */
  reasons: ReasonMetrics[];

  /**
   * example_dcns are a few cases carrying this errored code. AUDITOR-ONLY,
   * absent for everyone else: a case id beside agent_wrong/coder_wrong says
   * which slot of that case is the agent. Same gate as CodeAgreement's.
   *
   * @generated from field: repeated string example_dcns = 7;
   */
  exampleDcns: string[];
};

/**
 * Describes the message evalreview.v1.CodeMetrics.
 * Use `create(CodeMetricsSchema)` to create a new message.
 */
export const CodeMetricsSchema: GenMessage<CodeMetrics> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 21);

/**
 * ReasonMetrics is a study-wide reason tally. Distinct from
 * FieldMetrics.top_reasons, which is truncated per field — concatenating those
 * hides a reason that is a steady fourth place everywhere.
 *
 * @generated from message evalreview.v1.ReasonMetrics
 */
export type ReasonMetrics = Message<"evalreview.v1.ReasonMetrics"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;

  /**
   * codes are the codes this reason was cited against, ranked, floored at the
   * same occurrence floor as errored_codes, capped. On FieldMetrics.
   * top_reason_counts, limited to that field.
   *
   * @generated from field: repeated evalreview.v1.CodeCount codes = 3;
   */
  codes: CodeCount[];
};

/**
 * Describes the message evalreview.v1.ReasonMetrics.
 * Use `create(ReasonMetricsSchema)` to create a new message.
 */
export const ReasonMetricsSchema: GenMessage<ReasonMetrics> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 22);

/**
 * @generated from message evalreview.v1.CodeCount
 */
export type CodeCount = Message<"evalreview.v1.CodeCount"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: int32 count = 3;
   */
  count: number;
};

/**
 * Describes the message evalreview.v1.CodeCount.
 * Use `create(CodeCountSchema)` to create a new message.
 */
export const CodeCountSchema: GenMessage<CodeCount> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 23);

/**
 * CorpusExclusion is one reason cases could not be compared, and how many.
 * Reported separately rather than as a single "excluded" total because the
 * reasons have different remedies.
 *
 * @generated from message evalreview.v1.CorpusExclusion
 */
export type CorpusExclusion = Message<"evalreview.v1.CorpusExclusion"> & {
  /**
   * reason is phrased for the reader and deliberately NOT in the coding
   * agent's own vocabulary. "no surgical CPT extracted from chart" would name
   * which leg is the AI, and the A/B arrangement is stable per case.
   *
   * @generated from field: string reason = 1;
   */
  reason: string;

  /**
   * @generated from field: int32 cases = 2;
   */
  cases: number;
};

/**
 * Describes the message evalreview.v1.CorpusExclusion.
 * Use `create(CorpusExclusionSchema)` to create a new message.
 */
export const CorpusExclusionSchema: GenMessage<CorpusExclusion> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 24);

/**
 * FieldAgreement is how one field compares across the comparable corpus.
 *
 * @generated from message evalreview.v1.FieldAgreement
 */
export type FieldAgreement = Message<"evalreview.v1.FieldAgreement"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: int32 agree = 2;
   */
  agree: number;

  /**
   * @generated from field: int32 differ = 3;
   */
  differ: number;

  /**
   * not_comparable is its own column, never folded into either other one:
   * collapsing it is a claim the data does not support. A modifier only one
   * side populated is one side answering a question the other was not asked.
   *
   * @generated from field: int32 not_comparable = 4;
   */
  notComparable: number;

  /**
   * one_sided counts fields where one side produced codes and the other
   * produced none — a coverage gap rather than a coding disagreement.
   *
   * These used to be counted in `differ`, so the headline disagreement rate
   * included every case where a result was simply never produced. It is
   * excluded from the agreement denominator for the same reason: a case only
   * one side answered says nothing about who codes better.
   *
   * Deliberately says one side, never WHICH side. The A/B arrangement is
   * stable per case, so an aggregate that names the slot is an unblinding
   * oracle.
   *
   * @generated from field: int32 one_sided = 5;
   */
  oneSided: number;
};

/**
 * Describes the message evalreview.v1.FieldAgreement.
 * Use `create(FieldAgreementSchema)` to create a new message.
 */
export const FieldAgreementSchema: GenMessage<FieldAgreement> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 25);

/**
 * CodeAgreement is one specific code and how often both sides carried it.
 *
 * The code here is the COMPARISON key — 45378 and 45378DG are one row, and an
 * FY2026 ICD expansion is not a different diagnosis from its parent. Counting
 * raw strings would report the same code several times and understate each.
 *
 * Unlike CodeMetrics above, this attributes nothing to either side, so it needs
 * no rarity floor: seen/matched cannot tell a reviewer which slot is the agent.
 *
 * @generated from message evalreview.v1.CodeAgreement
 */
export type CodeAgreement = Message<"evalreview.v1.CodeAgreement"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * seen is comparable cases where EITHER side carried the code; matched is
   * those where both did. A code only one side ever picks is the most
   * interesting row in the table, so it is counted, not dropped.
   *
   * @generated from field: int32 seen = 3;
   */
  seen: number;

  /**
   * @generated from field: int32 matched = 4;
   */
  matched: number;

  /**
   * A few cases carrying this code, so a reader can open one instead of taking
   * the row's word for it. Capped, and first-by-corpus-order rather than
   * sampled, so the same row offers the same examples on a second load.
   *
   * SAFE HERE, and only here, because this row is SYMMETRIC: seen/matched say a
   * code appeared and whether both sides had it, never which side had it. The
   * errored-code table has no equivalent on purpose — its rows carry
   * agent_wrong/coder_wrong, so naming a case beside one would tell the reader
   * which SLOT of that case is the agent. That is the per-case provenance
   * lookup the service comment above says must not exist; it does not become
   * acceptable by arriving as a field instead of an RPC.
   *
   * @generated from field: repeated string example_dcns = 5;
   */
  exampleDcns: string[];
};

/**
 * Describes the message evalreview.v1.CodeAgreement.
 * Use `create(CodeAgreementSchema)` to create a new message.
 */
export const CodeAgreementSchema: GenMessage<CodeAgreement> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 26);

/**
 * FieldTrend is one scored field's slice of a TrendBucket. Verdict counters
 * obey the bucket's floor exactly as the bucket totals do (zero when the
 * bucket is unmeasured; weekly = sum of measured days); corpus counters are
 * never floored.
 *
 * It exists because the bucket totals average every field together, and the
 * fields do not move together: a surgical-CPT regression and a physical-status
 * improvement in the same week cancel in the total and are individually
 * invisible.
 *
 * @generated from message evalreview.v1.FieldTrend
 */
export type FieldTrend = Message<"evalreview.v1.FieldTrend"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * judged and the four side counters sum, over a bucket's fields, to that
   * bucket's own verdict totals.
   *
   * @generated from field: int32 judged = 2;
   */
  judged: number;

  /**
   * @generated from field: int32 agent_correct = 3;
   */
  agentCorrect: number;

  /**
   * @generated from field: int32 coder_correct = 4;
   */
  coderCorrect: number;

  /**
   * @generated from field: int32 both = 5;
   */
  both: number;

  /**
   * @generated from field: int32 neither = 6;
   */
  neither: number;

  /**
   * The four Agreement outcomes over the bucket's comparable cases — computed
   * from the two coded results alone, symmetric, and present before any
   * reviewer looks at the case, so no floor applies to them.
   *
   * @generated from field: int32 agree = 7;
   */
  agree: number;

  /**
   * @generated from field: int32 differ = 8;
   */
  differ: number;

  /**
   * @generated from field: int32 one_sided = 9;
   */
  oneSided: number;

  /**
   * @generated from field: int32 not_comparable = 10;
   */
  notComparable: number;
};

/**
 * Describes the message evalreview.v1.FieldTrend.
 * Use `create(FieldTrendSchema)` to create a new message.
 */
export const FieldTrendSchema: GenMessage<FieldTrend> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 27);

/**
 * TrendBucket is one day or ISO week of cases by RECEIVED date. Received
 * rather than reviewed: reviewers judge old cases late, so a review-date
 * series confounds a model change with a backlog catch-up.
 *
 * @generated from message evalreview.v1.TrendBucket
 */
export type TrendBucket = Message<"evalreview.v1.TrendBucket"> & {
  /**
   * YYYY-MM-DD in the requested zone
   *
   * @generated from field: string start = 1;
   */
  start: string;

  /**
   * @generated from field: int32 cases_received = 2;
   */
  casesReceived: number;

  /**
   * @generated from field: int32 comparable = 3;
   */
  comparable: number;

  /**
   * @generated from field: int32 fully_agreed = 4;
   */
  fullyAgreed: number;

  /**
   * @generated from field: int32 reviewed = 5;
   */
  reviewed: number;

  /**
   * measured is the blind-review floor: the verdict counters below are zero
   * and this is false unless the bucket holds enough reviews from enough
   * distinct reviewers. Render an unmeasured bucket as a gap, never as 0%.
   *
   * On a WEEKLY bucket the counters below are the SUM over that week's measured
   * DAILY buckets, and the floor is applied to those days' reviews and
   * reviewers. Both series ship here together, so an independently floored week
   * would be subtractable — week minus the measured days would be the verdicts
   * of the days the floor hid, and `reviewed` names which days those are.
   * Summing measured days makes that difference identically zero. `reviewed`
   * and the corpus counters stay the week's true totals; they name no side.
   *
   * @generated from field: bool measured = 6;
   */
  measured: boolean;

  /**
   * @generated from field: int32 judged = 7;
   */
  judged: number;

  /**
   * @generated from field: int32 agent_correct = 8;
   */
  agentCorrect: number;

  /**
   * @generated from field: int32 coder_correct = 9;
   */
  coderCorrect: number;

  /**
   * @generated from field: int32 both = 10;
   */
  both: number;

  /**
   * @generated from field: int32 neither = 11;
   */
  neither: number;

  /**
   * fields is one entry per scored field, in the server's scored-field order,
   * on every bucket that saw a case. A zero-filled gap bucket carries none:
   * there is no case behind it to slice. An ABSENT entry is not a measured
   * zero — render it the same way an unmeasured bucket is rendered.
   *
   * @generated from field: repeated evalreview.v1.FieldTrend fields = 12;
   */
  fields: FieldTrend[];
};

/**
 * Describes the message evalreview.v1.TrendBucket.
 * Use `create(TrendBucketSchema)` to create a new message.
 */
export const TrendBucketSchema: GenMessage<TrendBucket> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 28);

/**
 * ThroughputBucket counts reviews by the day or week they were SUBMITTED.
 *
 * @generated from message evalreview.v1.ThroughputBucket
 */
export type ThroughputBucket = Message<"evalreview.v1.ThroughputBucket"> & {
  /**
   * @generated from field: string start = 1;
   */
  start: string;

  /**
   * @generated from field: int32 reviews_submitted = 2;
   */
  reviewsSubmitted: number;
};

/**
 * Describes the message evalreview.v1.ThroughputBucket.
 * Use `create(ThroughputBucketSchema)` to create a new message.
 */
export const ThroughputBucketSchema: GenMessage<ThroughputBucket> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 29);

/**
 * @generated from message evalreview.v1.GetProgramMetricsResponse
 */
export type GetProgramMetricsResponse = Message<"evalreview.v1.GetProgramMetricsResponse"> & {
  /**
   * judged counts FIELD-level judgements; cases counts distinct reviewed cases.
   * Both are returned because quoting the field-level number as a case count
   * overstates the sample by roughly the number of fields per case.
   *
   * @generated from field: int32 judged = 1;
   */
  judged: number;

  /**
   * @generated from field: int32 cases = 2;
   */
  cases: number;

  /**
   * @generated from field: int32 agent_correct = 3;
   */
  agentCorrect: number;

  /**
   * @generated from field: int32 coder_correct = 4;
   */
  coderCorrect: number;

  /**
   * @generated from field: int32 both = 5;
   */
  both: number;

  /**
   * @generated from field: int32 neither = 6;
   */
  neither: number;

  /**
   * excluded counts submitted reviews skipped because they were resolved under
   * a superseded or unknown study key, and so describe a slot mapping that no
   * longer holds. Surfaced rather than dropped: a non-zero value means the
   * denominator moved, and a reader is entitled to know.
   *
   * @generated from field: int32 excluded = 7;
   */
  excluded: number;

  /**
   * Rates, precomputed server-side so every caller reports the same number.
   * "both" counts as correct for BOTH sides — it says each produced an
   * acceptable result.
   *
   * @generated from field: double agent_accuracy = 8;
   */
  agentAccuracy: number;

  /**
   * @generated from field: double coder_accuracy = 9;
   */
  coderAccuracy: number;

  /**
   * agreement is both+neither over judged: how often the reviewer could not
   * separate them. It measures indistinguishability, not quality — which is why
   * neither is reported on its own above.
   *
   * @generated from field: double agreement = 10;
   */
  agreement: number;

  /**
   * @generated from field: repeated evalreview.v1.FieldMetrics fields = 11;
   */
  fields: FieldMetrics[];

  /**
   * has_data distinguishes "measured zero" from "nothing measured". Without it
   * an empty study renders as 0% accuracy, which reads as a failing agent
   * rather than an empty corpus.
   *
   * @generated from field: bool has_data = 12;
   */
  hasData: boolean;

  /**
   * ── Autocoder vs auditor SELECTIONS ──
   *
   * A different question from accuracy above, and the difference is the
   * denominator. Accuracy divides by every judgement, so a "neither" — the
   * record was unreadable, no code was supportable — counts against the agent
   * exactly as hard as a judgement the human coder won. The selection rates
   * divide by selection_resolved: judgements where the reviewer NAMED a correct
   * answer. Among those, how often was the answer the agent's.
   *
   * selection_resolved is also the has_data of this pair. Zero means no
   * selection rate was measured, and a client must render NOT MEASURED rather
   * than the 0.0 the rate fields carry — a rate of zero over zero judgements
   * reads as an agent that never once matched the auditor.
   *
   * @generated from field: int32 selection_resolved = 13;
   */
  selectionResolved: number;

  /**
   * selection_unresolved counts judgements where the reviewer rejected both
   * sides AND recorded no correct code, so there is nothing to match against.
   *
   * A rejection WITH a replacement code is resolved and counts in the
   * denominator above, against both sides — the reviewer named an answer and
   * neither result was it. Only the ones with no answer on file land here.
   *
   * Reported beside the rates, not folded into them: while this is non-zero the
   * rates above remain an UPPER BOUND, because each of these judgements would
   * enter the denominator without entering either numerator. Quoting them as
   * final while this is non-zero overstates both sides.
   *
   * @generated from field: int32 selection_unresolved = 14;
   */
  selectionUnresolved: number;

  /**
   * @generated from field: double agent_selection_match = 15;
   */
  agentSelectionMatch: number;

  /**
   * @generated from field: double coder_selection_match = 16;
   */
  coderSelectionMatch: number;

  /**
   * errored_codes ranks the specific codes judged wrong, worst first — the
   * actionable output of this whole surface. A field-level rate says the agent
   * is weak on modifiers; this says which modifier to go fix.
   *
   * Floored: a code seen erring only once or twice is withheld, because a
   * single-case row is not an aggregate. A reviewer who just judged a case,
   * saw slot A hold 00790, and then reads "00790 · 1 agent error" has learned
   * which slot is the agent — and the arrangement is stable per case, so that
   * lesson applies to every case they see afterwards.
   *
   * @generated from field: repeated evalreview.v1.CodeMetrics errored_codes = 17;
   */
  erroredCodes: CodeMetrics[];

  /**
   * errored_codes_suppressed counts distinct field+code pairs the floor
   * removed, so the list reads as "the recurring offenders" instead of passing
   * itself off as every code that ever went wrong.
   *
   * @generated from field: int32 errored_codes_suppressed = 18;
   */
  erroredCodesSuppressed: number;

  /**
   * top_reasons is the study-wide reason ranking, with counts.
   *
   * @generated from field: repeated evalreview.v1.ReasonMetrics top_reasons = 19;
   */
  topReasons: ReasonMetrics[];

  /**
   * ── Corpus agreement, measured with no reviewer input ──
   *
   * corpus_cases is every case in the store; corpus_comparable is how many had
   * both sides and were not withheld, and is the denominator every corpus rate
   * is quoted over. The two are returned separately because quoting a rate over
   * the case count would understate agreement by the whole exclusion set.
   *
   * @generated from field: int32 corpus_cases = 20;
   */
  corpusCases: number;

  /**
   * @generated from field: int32 corpus_comparable = 21;
   */
  corpusComparable: number;

  /**
   * corpus_fully_agreed is comparable cases where no field DIFFERED. A field
   * that could not be compared does not spoil a full agreement.
   *
   * @generated from field: int32 corpus_fully_agreed = 22;
   */
  corpusFullyAgreed: number;

  /**
   * @generated from field: repeated evalreview.v1.CorpusExclusion corpus_exclusions = 23;
   */
  corpusExclusions: CorpusExclusion[];

  /**
   * @generated from field: repeated evalreview.v1.FieldAgreement corpus_fields = 24;
   */
  corpusFields: FieldAgreement[];

  /**
   * @generated from field: repeated evalreview.v1.CodeAgreement corpus_codes = 25;
   */
  corpusCodes: CodeAgreement[];

  /**
   * corpus_codes_suppressed is how many distinct field+code rows the server's
   * cap removed, so the table reads as a top-N instead of passing itself off as
   * every code the study has seen.
   *
   * @generated from field: int32 corpus_codes_suppressed = 26;
   */
  corpusCodesSuppressed: number;

  /**
   * Trend series, daily and weekly. Each DAY is floored on its own counts; a
   * week's verdict counters are the sum over its measured days (see
   * TrendBucket.measured), so subtracting the days from the week recovers
   * nothing.
   *
   * @generated from field: repeated evalreview.v1.TrendBucket trend_daily = 27;
   */
  trendDaily: TrendBucket[];

  /**
   * @generated from field: repeated evalreview.v1.TrendBucket trend_weekly = 28;
   */
  trendWeekly: TrendBucket[];

  /**
   * @generated from field: repeated evalreview.v1.ThroughputBucket reviews_daily = 29;
   */
  reviewsDaily: ThroughputBucket[];

  /**
   * @generated from field: repeated evalreview.v1.ThroughputBucket reviews_weekly = 30;
   */
  reviewsWeekly: ThroughputBucket[];

  /**
   * errored_codes_capped counts rows that cleared the floor but fell past the
   * cap — a different reason to be missing than errored_codes_suppressed.
   *
   * @generated from field: int32 errored_codes_capped = 31;
   */
  erroredCodesCapped: number;

  /**
   * verdict_floor_cleared is the study-wide blind floor: the verdict block
   * (fields 1, 3–6, 8–11, 13–19, 31) is served only when at least
   * min_floor_reviews reviewed cases from min_floor_reviewers distinct
   * reviewers exist. Below it those fields are zero/empty and has_data is
   * false, while `cases` still carries the reviewed count so the client can
   * say why nothing is measured. Same rule as TrendBucket.measured.
   *
   * 31 (errored_codes_capped) is withheld along with 17/18
   * (errored_codes/errored_codes_suppressed): a non-zero cap count beside an
   * empty errored_codes list would say "more exist" about a list this
   * response is otherwise hiding entirely, which is a partial leak of the
   * same shape the floor exists to close.
   *
   * @generated from field: bool verdict_floor_cleared = 32;
   */
  verdictFloorCleared: boolean;

  /**
   * @generated from field: int32 min_floor_reviews = 33;
   */
  minFloorReviews: number;

  /**
   * @generated from field: int32 min_floor_reviewers = 34;
   */
  minFloorReviewers: number;
};

/**
 * Describes the message evalreview.v1.GetProgramMetricsResponse.
 * Use `create(GetProgramMetricsResponseSchema)` to create a new message.
 */
export const GetProgramMetricsResponseSchema: GenMessage<GetProgramMetricsResponse> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 30);

/**
 * @generated from message evalreview.v1.ListCodeCasesRequest
 */
export type ListCodeCasesRequest = Message<"evalreview.v1.ListCodeCasesRequest"> & {
  /**
   * @generated from field: evalreview.v1.CodeCaseMode mode = 1;
   */
  mode: CodeCaseMode;

  /**
   * @generated from field: string field = 2;
   */
  field: string;

  /**
   * comparison key, as the tables show it
   *
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * ERRORED only
   *
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message evalreview.v1.ListCodeCasesRequest.
 * Use `create(ListCodeCasesRequestSchema)` to create a new message.
 */
export const ListCodeCasesRequestSchema: GenMessage<ListCodeCasesRequest> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 31);

/**
 * @generated from message evalreview.v1.CodeCase
 */
export type CodeCase = Message<"evalreview.v1.CodeCase"> & {
  /**
   * DCN
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string episode_id = 2;
   */
  episodeId: string;

  /**
   * @generated from field: string batch_id = 3;
   */
  batchId: string;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 4;
   */
  receivedAt?: Timestamp | undefined;

  /**
   * ERRORED only
   *
   * @generated from field: google.protobuf.Timestamp review_submitted_at = 5;
   */
  reviewSubmittedAt?: Timestamp | undefined;

  /**
   * @generated from field: string field = 6;
   */
  field: string;

  /**
   * @generated from field: string code = 7;
   */
  code: string;

  /**
   * ERRORED: agent | coder — the side judged wrong
   *
   * @generated from field: string side = 8;
   */
  side: string;

  /**
   * ERRORED: agent | coder | both | neither
   *
   * @generated from field: string verdict = 9;
   */
  verdict: string;

  /**
   * ERRORED: reason ids
   *
   * @generated from field: repeated string reasons = 10;
   */
  reasons: string[];

  /**
   * CORPUS: both sides carried the code
   *
   * @generated from field: bool matched = 11;
   */
  matched: boolean;
};

/**
 * Describes the message evalreview.v1.CodeCase.
 * Use `create(CodeCaseSchema)` to create a new message.
 */
export const CodeCaseSchema: GenMessage<CodeCase> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 32);

/**
 * @generated from message evalreview.v1.ListCodeCasesResponse
 */
export type ListCodeCasesResponse = Message<"evalreview.v1.ListCodeCasesResponse"> & {
  /**
   * @generated from field: repeated evalreview.v1.CodeCase cases = 1;
   */
  cases: CodeCase[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message evalreview.v1.ListCodeCasesResponse.
 * Use `create(ListCodeCasesResponseSchema)` to create a new message.
 */
export const ListCodeCasesResponseSchema: GenMessage<ListCodeCasesResponse> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 33);

/**
 * @generated from message evalreview.v1.AssignBatchRequest
 */
export type AssignBatchRequest = Message<"evalreview.v1.AssignBatchRequest"> & {
  /**
   * @generated from field: string queue_id = 1;
   */
  queueId: string;

  /**
   * @generated from field: string batch_id = 2;
   */
  batchId: string;

  /**
   * reviewer_ids, when set, REPLACES the queue's membership. Empty leaves it
   * unchanged, so assigning a batch does not silently unassign every reviewer.
   *
   * @generated from field: repeated string reviewer_ids = 3;
   */
  reviewerIds: string[];

  /**
   * @generated from field: string queue_name = 4;
   */
  queueName: string;
};

/**
 * Describes the message evalreview.v1.AssignBatchRequest.
 * Use `create(AssignBatchRequestSchema)` to create a new message.
 */
export const AssignBatchRequestSchema: GenMessage<AssignBatchRequest> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 34);

/**
 * @generated from message evalreview.v1.AssignBatchResponse
 */
export type AssignBatchResponse = Message<"evalreview.v1.AssignBatchResponse"> & {
  /**
   * @generated from field: evalreview.v1.Queue queue = 1;
   */
  queue?: Queue | undefined;
};

/**
 * Describes the message evalreview.v1.AssignBatchResponse.
 * Use `create(AssignBatchResponseSchema)` to create a new message.
 */
export const AssignBatchResponseSchema: GenMessage<AssignBatchResponse> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 35);

/**
 * @generated from message evalreview.v1.UnassignBatchRequest
 */
export type UnassignBatchRequest = Message<"evalreview.v1.UnassignBatchRequest"> & {
  /**
   * The queue to remove it from. REQUIRED, and deliberately not inferred from
   * "wherever the batch happens to be": during a migration a batch can sit in
   * two queues, and an unassign that guessed would silently revoke the wrong
   * reviewer's access.
   *
   * @generated from field: string queue_id = 1;
   */
  queueId: string;

  /**
   * @generated from field: string batch_id = 2;
   */
  batchId: string;
};

/**
 * Describes the message evalreview.v1.UnassignBatchRequest.
 * Use `create(UnassignBatchRequestSchema)` to create a new message.
 */
export const UnassignBatchRequestSchema: GenMessage<UnassignBatchRequest> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 36);

/**
 * @generated from message evalreview.v1.UnassignBatchResponse
 */
export type UnassignBatchResponse = Message<"evalreview.v1.UnassignBatchResponse"> & {
  /**
   * @generated from field: evalreview.v1.Queue queue = 1;
   */
  queue?: Queue | undefined;

  /**
   * Whether the batch was actually in the queue.
   *
   * Removal is idempotent — unassigning twice is not an error, because the
   * second call describes the state the caller wanted. But a caller that
   * mistyped a batch id would otherwise get an indistinguishable success, so
   * the no-op is reported rather than hidden.
   *
   * @generated from field: bool removed = 2;
   */
  removed: boolean;
};

/**
 * Describes the message evalreview.v1.UnassignBatchResponse.
 * Use `create(UnassignBatchResponseSchema)` to create a new message.
 */
export const UnassignBatchResponseSchema: GenMessage<UnassignBatchResponse> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 37);

/**
 * @generated from message evalreview.v1.ListQueuesRequest
 */
export type ListQueuesRequest = Message<"evalreview.v1.ListQueuesRequest"> & {
};

/**
 * Describes the message evalreview.v1.ListQueuesRequest.
 * Use `create(ListQueuesRequestSchema)` to create a new message.
 */
export const ListQueuesRequestSchema: GenMessage<ListQueuesRequest> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 38);

/**
 * @generated from message evalreview.v1.ListQueuesResponse
 */
export type ListQueuesResponse = Message<"evalreview.v1.ListQueuesResponse"> & {
  /**
   * @generated from field: repeated evalreview.v1.Queue queues = 1;
   */
  queues: Queue[];
};

/**
 * Describes the message evalreview.v1.ListQueuesResponse.
 * Use `create(ListQueuesResponseSchema)` to create a new message.
 */
export const ListQueuesResponseSchema: GenMessage<ListQueuesResponse> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 39);

/**
 * @generated from message evalreview.v1.Queue
 */
export type Queue = Message<"evalreview.v1.Queue"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated string batch_ids = 3;
   */
  batchIds: string[];

  /**
   * @generated from field: repeated string reviewer_ids = 4;
   */
  reviewerIds: string[];

  /**
   * Display identity for the ids in reviewer_ids, resolved server-side.
   *
   * reviewer_ids are opaque principal ids, so a client rendering assignment
   * could only ever show "01a01b6e-435c-7957-8490-d8fa4197242f" where a name
   * belongs — which does not answer the one question assignment exists to
   * answer. Resolved here rather than by the client because the alternative is
   * granting every reviewer ListPrincipals, i.e. a whole principal directory,
   * to render six names.
   *
   * Best-effort and possibly SHORTER than reviewer_ids: a principal that cannot
   * be resolved is omitted rather than echoed back as its own id, so a caller
   * can tell "no name known" from "the name happens to look like an id".
   * reviewer_ids stays authoritative for membership.
   *
   * Not a blinding concern: routing is a domain-separated unkeyed digest over
   * (batch, reviewer) and the A/B arrangement is HMAC(study_key, dcn), so who
   * holds a batch carries no information about which slot is the agent.
   *
   * @generated from field: repeated evalreview.v1.Reviewer reviewers = 5;
   */
  reviewers: Reviewer[];
};

/**
 * Describes the message evalreview.v1.Queue.
 * Use `create(QueueSchema)` to create a new message.
 */
export const QueueSchema: GenMessage<Queue> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 40);

/**
 * A principal who draws from a queue, with the identity needed to say WHO.
 *
 * @generated from message evalreview.v1.Reviewer
 */
export type Reviewer = Message<"evalreview.v1.Reviewer"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Human display name. Never an email — this renders in shared views.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;
};

/**
 * Describes the message evalreview.v1.Reviewer.
 * Use `create(ReviewerSchema)` to create a new message.
 */
export const ReviewerSchema: GenMessage<Reviewer> = /*@__PURE__*/
  messageDesc(file_evalreview_v1_evalreview, 41);

/**
 * @generated from enum evalreview.v1.CodeCaseMode
 */
export enum CodeCaseMode {
  /**
   * @generated from enum value: CODE_CASE_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Comparable cases where either side carried the code (the corpus table).
   *
   * @generated from enum value: CODE_CASE_MODE_CORPUS = 1;
   */
  CORPUS = 1,

  /**
   * Scorable reviewed cases where a side was judged wrong on the code (the
   * errored-code table and the reason lists).
   *
   * @generated from enum value: CODE_CASE_MODE_ERRORED = 2;
   */
  ERRORED = 2,
}

/**
 * Describes the enum evalreview.v1.CodeCaseMode.
 */
export const CodeCaseModeSchema: GenEnum<CodeCaseMode> = /*@__PURE__*/
  enumDesc(file_evalreview_v1_evalreview, 0);

/**
 * EvalReviewService serves the reviewer workbench: it queries the eval read
 * model (batches, blind cases, codebook) and records reviewer verdicts as
 * domain events (CQRS — queries read the projection, the command appends
 * events).
 *
 * Blind-review invariant: a case's two coded results are exposed only as opaque
 * A/B slots. Provenance (which slot is the AI agent vs the human coder) is
 * withheld server-side and never crosses this wire.
 *
 * @generated from service evalreview.v1.EvalReviewService
 */
export const EvalReviewService: GenService<{
  /**
   * ListBatches returns the review batches (M1: synthesized per ingest day;
   * M2 replaces them with FA episode->batch).
   *
   * @generated from rpc evalreview.v1.EvalReviewService.ListBatches
   */
  listBatches: {
    methodKind: "unary";
    input: typeof ListBatchesRequestSchema;
    output: typeof ListBatchesResponseSchema;
  },
  /**
   * ListCases returns the case summaries in a batch (the review queue).
   *
   * @generated from rpc evalreview.v1.EvalReviewService.ListCases
   */
  listCases: {
    methodKind: "unary";
    input: typeof ListCasesRequestSchema;
    output: typeof ListCasesResponseSchema;
  },
  /**
   * GetCase returns one case as a blind A/B pair.
   *
   * @generated from rpc evalreview.v1.EvalReviewService.GetCase
   */
  getCase: {
    methodKind: "unary";
    input: typeof GetCaseRequestSchema;
    output: typeof GetCaseResponseSchema;
  },
  /**
   * SearchCodebook looks up code titles/descriptions for display.
   *
   * @generated from rpc evalreview.v1.EvalReviewService.SearchCodebook
   */
  searchCodebook: {
    methodKind: "unary";
    input: typeof SearchCodebookRequestSchema;
    output: typeof SearchCodebookResponseSchema;
  },
  /**
   * SubmitReview records a reviewer's per-field verdicts + case disposition by
   * appending an eval.review.submitted event.
   *
   * @generated from rpc evalreview.v1.EvalReviewService.SubmitReview
   */
  submitReview: {
    methodKind: "unary";
    input: typeof SubmitReviewRequestSchema;
    output: typeof SubmitReviewResponseSchema;
  },
  /**
   * GetProgramMetrics returns the study-wide agent-vs-coder aggregate.
   *
   * This is the ONLY surface that speaks in provenance terms, and it is safe
   * precisely because it is an aggregate: "the agent is at 78%" reveals nothing
   * about the case a reviewer currently has open. A per-case provenance lookup
   * would hand over the scheme for every future case that reviewer sees, since
   * the slot arrangement is stable per case — so no such RPC exists, and none
   * should be added.
   *
   * @generated from rpc evalreview.v1.EvalReviewService.GetProgramMetrics
   */
  getProgramMetrics: {
    methodKind: "unary";
    input: typeof GetProgramMetricsRequestSchema;
    output: typeof GetProgramMetricsResponseSchema;
  },
  /**
   * ListCodeCases returns the cases behind one row of the program-metrics
   * report — the drill-in from a code or a reason to the cases that produced
   * it. AUDITOR-ONLY: in ERRORED mode a row names which side of a case was
   * judged wrong, which is per-case provenance. A caller without the
   * all-batches grant is refused with PermissionDenied. Served rows are
   * access-logged by count.
   *
   * @generated from rpc evalreview.v1.EvalReviewService.ListCodeCases
   */
  listCodeCases: {
    methodKind: "unary";
    input: typeof ListCodeCasesRequestSchema;
    output: typeof ListCodeCasesResponseSchema;
  },
  /**
   * AssignBatch places a batch in a reviewer queue, and ensures the queue's
   * reviewer membership. This is the ONLY way scope is granted, so it is
   * separately authorized (eval_batch:write) — assigning work decides who may
   * read PHI, which is an access-control act even though it is stored as data.
   * The separation is the RESOURCE segment: eval_batch is not eval_case, so no
   * reviewer grant reaches this. (Said `eval_batch:assign` until 2026-08-07; the
   * interceptor has always required a write, and a role built from the old
   * wording was denied with no hint that the name was the problem.)
   *
   * @generated from rpc evalreview.v1.EvalReviewService.AssignBatch
   */
  assignBatch: {
    methodKind: "unary";
    input: typeof AssignBatchRequestSchema;
    output: typeof AssignBatchResponseSchema;
  },
  /**
   * Removes a batch from a queue. The counterpart to AssignBatch, and the only
   * way assignment is ever revoked — the sweeper never takes work back.
   *
   * @generated from rpc evalreview.v1.EvalReviewService.UnassignBatch
   */
  unassignBatch: {
    methodKind: "unary";
    input: typeof UnassignBatchRequestSchema;
    output: typeof UnassignBatchResponseSchema;
  },
  /**
   * ListQueues returns queues and their assignments, for the assignment UI.
   *
   * @generated from rpc evalreview.v1.EvalReviewService.ListQueues
   */
  listQueues: {
    methodKind: "unary";
    input: typeof ListQueuesRequestSchema;
    output: typeof ListQueuesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_evalreview_v1_evalreview, 0);

